var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOrderTypeRendering(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_140_32337)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.8737 6.02289L7.40001 10.9534C7.34843 10.9839 7.3158 11.0397 7.3158 11.0997V20.8451C7.3158 20.9061 7.34843 20.9619 7.40106 20.9914L15.9032 25.8756C15.9547 25.9051 16.0179 25.9049 16.0705 25.8765L24.5926 21.0851C24.6463 21.0556 24.679 20.9987 24.679 20.9377V11.0997C24.679 11.0397 24.6463 10.9829 24.5947 10.9534L16.0442 6.02289C15.9905 5.99237 15.9263 5.99237 15.8737 6.02289ZM24.2516 20.884L16.6421 25.1619C16.5284 25.2261 16.3884 25.1429 16.3905 25.0135L16.4674 16.1534C16.4684 16.0934 16.5011 16.0376 16.5526 16.0082L24.0853 11.7324C24.1979 11.6682 24.3379 11.7503 24.3379 11.8797V20.7377C24.3369 20.7977 24.3042 20.8545 24.2516 20.884Z",
    fill: "#12181E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_140_32337"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.3684,
    height: 20,
    fill: "white",
    transform: "translate(7.3158 6)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderTypeRendering);
export default __webpack_public_path__ + "static/media/order_type_rendering.8f4192ffa17b7336b44f7f5d4abaea41.svg";
export { ForwardRef as ReactComponent };